<template>
  <div class="container_dash">
    <div class="row content_date justify-content-center">
      <div class="col-12 col-md-3 col-lg-3">
        <input
          v-model="form.initialDate"
          type="text"
          class="form-control"
          placeholder="Fecha inicial *"
          onfocus="(this.type='date')"
          min="2020-01-01"
          :max="maxDateInitial()"
        >
      </div>
      <div class="col-12 col-md-3 col-lg-3">
        <input
          v-model="form.finallyDate"
          type="text"
          class="form-control"
          id="finallyDate"
          placeholder="Fecha final *"
          onfocus="(this.type='date')"
          min="2020-01-31"
          :max="maxDateFinally()"
          disabled
        >
      </div>
      <div class="col-12 col-md-1 col-lg-1 btn_search">
        <button
          class="btn btn-danger btn-sm"
          @click="getReport()"
        >
          <div v-if="utils.searching" style="display:flex;">
            <span>
              Consultando...&nbsp;
            </span>
            <div class="loader"></div>
          </div>
          <span v-else class="fas fa-search"></span>
        </button>
      </div>
      <div class="info col-12 col-md-12 col-lg-12">
        <strong>El tiempo de carga depende del rango de fechas ingresadas y la velocidad de tu internet.</strong>
      </div>
    </div>

    <div v-if="utils.result" class="cont_graphs_and_tables">

      <div class="row justify-content-initial">
        <span class="cant_users">Moteros registrados: <strong style="color:#dc3545;">{{ totalRegisterBikers }}</strong></span>
      </div>

      <div v-if="totalRegisterBikers > 0" class="row">
        <div class="col-12 col-md-12 col-lg-12">
          <!-- <h2 class="title_sec_1">Códigos ingresados por Moteros por mes y año</h2> -->
          <div class="chart-container">
            <v-chart class="chart" :option="usersByYear" />
          </div>
        </div>
      </div>

      <div v-if="bikersRedemtions.length > 0" class="row row_table">
        <div class="row justify-content-center">
          <span class="cant_users">Redenciones realizadas por moteros: <strong style="color:#dc3545;">{{ bikersRedemtions.length }}</strong></span>
        </div>
        <div class="col-12 col-md-12 col-lg-12">
          <h2 class="title_sec_1">Redenciones de Moteros</h2>
          <div class="codes_general">
            <table class="table">
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Fecha de redención</th>
                  <th scope="col">Nombre de producto</th>
                  <th scope="col">Nombre de usuario</th>
                  <th scope="col">Número de documento</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Email</th>
                  <th scope="col">Departamento</th>
                  <th scope="col">Ciudad</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in bikersRedemtions" :key="item.id">
                  <td>{{ item.order_date }}</td>
                  <td>{{ item.product_name }}</td>
                  <td v-if="item.name != null && item.last_name != null">{{ item.name + ' ' + item.last_name }}</td>
                  <td v-else>{{ item.name }}</td>
                  <td>{{ item.document_number }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.state_name }}</td>
                  <td>{{ item.city_name }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <button
            class="btn btn-sm btn_download"
            @click="downloadReports(1)"
          >
            <b>Descargar</b>&nbsp;<i class="fas fa-download"></i>
          </button>
        </div>
      </div>
      <div v-else class="row justify-content-center">
        <span class="without">Sin redenciones</span>
      </div>

      <div v-if="expiredPoints.length > 0" class="row row_table">
        <div class="col-12 col-md-12 col-lg-12">
          <h2 class="title_sec_1">Puntos a vencer Moteros</h2>
          <div class="codes_general">
            <table class="table">
              <caption class="visually-hidden">Listado de Códigos</caption>
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Nombre de usuario</th>
                  <!-- <th scope="col">Número de documento</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Email</th> -->
                  <th scope="col">Puntos a vencer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in expiredPoints" :key="item.id">
                  <td v-if="item.name != null && item.last_name != null">{{ item.name + ' ' + item.last_name }}</td>
                  <td v-else>{{ item.name }}</td>
                  <!-- <td>{{ item.document_number }}</td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email }}</td> -->
                  <td>{{ parseFloat(item.expiredPoints).toLocaleString() }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <button
            class="btn btn-sm btn_download"
            @click="downloadReports(2)"
          >
            <b>Descargar</b>&nbsp;<i class="fas fa-download"></i>
          </button> -->
        </div>
      </div>
      <div v-else class="row justify-content-center">
        <span class="without">Sin puntos a vencer</span>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import * as XLSX from 'xlsx';

// Importaciones para las graficas
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent,
]);

export default {
  name: "Dashboard",

  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "dark"
  },

  data() {
    return {
      utils: {
        searching: false,
        result: false,
      },
      form:{
        initialDate: null,
        finallyDate: null
      },
      totalRegisterBikers: 0,
      usersChart: [],
      bikersRedemtions: [],
      expiredPoints: [],

      // Estructura de la gráfica de "Moteros registrados por mes y año"
      usersByYear: {
        title: {
          text: "Moteros registrados por mes y año",
          left: "center",
          textStyle: {
            fontFamily: 'GothamBookItalic'
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {            
            type: 'shadow'        
          },
        },
        xAxis: {
          type: "category",
          data: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
          ]
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "Moteros registrados por mes y año",
            type: "bar",
            data: [],
            emphasis: {
              focus: "series"
            },
            itemStyle: {
              color: '#dc3545'
            }
          }
        ]
      },

    };
  },
  methods: {
    maxDateInitial(){
      const now = new Date();
      now.setMonth(now.getMonth() - 1);
      return now.toISOString().substr(0, 10);
    },
    maxDateFinally(){
      if (this.form.initialDate) {
        const maxDate = new Date(this.form.initialDate);
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        return maxDate.toISOString().split('T')[0];
      } else {
        const now = new Date();
        // now.setFullYear(now.getFullYear() - 18);
        return now.toISOString().substr(0, 10);
      }
    },
    checkForm(){
      if(this.form.initialDate == null){
        this.$swal({
          icon: "info",
          title: "Lo sentimos",
          text: "Para continuar debe ingresar una fecha inicial",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      if(this.form.finallyDate == null){
        this.$swal({
          icon: "info",
          title: "Lo sentimos",
          text: "Para continuar debe ingresar una fecha final",
          confirmButtonColor: "#dc3545"
        });
        return false;
      }
      if(this.form.initialDate && this.form.finallyDate){
        return true;
      }
    },
    getReport(){
      if(this.checkForm()){
        this.utils.searching = true;
        this.totalRegisterBikers = 0;
        this.usersChart = [],
        this.bikersRedemtions = [];
        this.expiredPoints = [];
        axios
        .post('api/get-report-biker/', this.form)
        .then(response => {
          if(response.data.cod == 0){
            this.usersChart = response.data.data.bikersByDist;
            if(this.usersChart.length > 0){
              this.usersChart.forEach(user => {
                if(user.id){
                  this.totalRegisterBikers++;
                }
              });
              this.updateChartUsersByYear();
            }
            let redemptions = response.data.data.bikerRedemptions;
            redemptions.forEach(element => {
              if(element){
                this.bikersRedemtions.push(element);
              }
            });
            let pointsUser = response.data.data.expiredPoints;
            pointsUser.forEach(item => {
              if(item.expiredPoints > 0){
                this.expiredPoints.push(item);
              }
            });
            this.utils.searching = false;
            this.utils.result = true;
          } else {
            this.$swal({
              icon: "warning",
              title: "Lo sentimos",
              text: response.data.message,
              confirmButtonColor: "#dc3545"
            });
            this.utils.searching = false;
            this.utils.result = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.utils.searching = false;
          this.utils.result = false;
        });
      }
    },
    updateChartUsersByYear() {
      var recuentoPorMes = {
        "Enero": 0, "Febrero": 0, "Marzo": 0, "Abril": 0, "Mayo": 0, "Junio": 0,
        "Julio": 0, "Agosto": 0, "Septiembre": 0, "Octubre": 0, "Noviembre": 0, "Diciembre": 0
      };

      this.usersChart.forEach(item => {
        var fecha = item.created_at;
        var partesFecha = fecha.split("-");
        var mes = parseInt(partesFecha[1], 10) - 1;
        var nombreMes = this.obtenerNombreMes(mes);
        recuentoPorMes[nombreMes]++;
      });

      var fechaInicio = new Date(this.form.initialDate + 'T00:00:00');
      var fechaFin = new Date(this.form.finallyDate + 'T23:59:59');

      var mesesEnRango = [];

      while (fechaInicio <= fechaFin) {
        mesesEnRango.push(this.obtenerNombreMes(fechaInicio.getMonth()));
        fechaInicio.setMonth(fechaInicio.getMonth() + 1);
      }

      var datosParaGrafico = mesesEnRango.map(mes => recuentoPorMes[mes]);

      this.usersByYear.xAxis.data = mesesEnRango;
      this.usersByYear.series[0].data = datosParaGrafico;
    },
    obtenerNombreMes(numeroMes) {
      var meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      return meses[numeroMes];
    },
    downloadReports(type){
      this.$swal({
        icon: "question",
        title: "Descargar",
        text: "¿Quieres descargar el reporte?",
        confirmButtonText: "Sí, descargar",
        confirmButtonColor: "#28a745",
        showCancelButton: true,
        cancelButtonText: "No",
        cancelButtonColor: "#dc3545"
      }).then(res => {
        if(res.isConfirmed){
          if(type == 1){
            const reportRedemptions = [];
            this.redemptions.forEach((item) => {
              var completeName;
              item.last_name != null ? completeName = item.name + ' ' + item.last_name : completeName = item.name;
              reportRedemptions.push({
                Fecha_De_Redención: item.order_date,
                Nombre_De_Producto: item.product_name,
                Nombre_De_Usuario: completeName,
                Cédula: item.document_number,
                Celular: item.phone,
                Email: item.email,
                Departamento: item.state_name,
                Ciudad: item.city_name,
              });
            });
            const data = XLSX.utils.json_to_sheet(reportRedemptions);
            // Ancho de columnas
            const totalColumns = XLSX.utils.decode_range(data['!ref']).e.c + 1;
            data['!cols'] = Array(totalColumns).fill({ wch: 20 });
            // Atura de filas
            const totalRows = XLSX.utils.decode_range(data['!ref']).e.r + 1;
            data['!rows'] = Array(totalRows).fill({ hpx: 20 });

            const workbook = XLSX.utils.book_new();
            const filename = 'Reporte-de-redenciones';
            XLSX.utils.book_append_sheet(workbook, data, filename);
            XLSX.writeFile(workbook, `${filename}.xlsx`);
          } else {
            const reportExpiredPoints = [];
            this.expiredPoints.forEach((item) => {
              var completeName;
              item.last_name != null ? completeName = item.name + ' ' + item.last_name : completeName = item.name;
              reportExpiredPoints.push({
                Fecha_De_Descarga: new Date(),
                Nombre_De_Usuario: completeName,
                Cédula: item.document_number,
                Celular: item.phone,
                Email: item.email,
                Puntos_A_Vencer: item.expiredPoints
              });
            });
            const data = XLSX.utils.json_to_sheet(reportExpiredPoints);
            // Ancho de columnas
            const totalColumns = XLSX.utils.decode_range(data['!ref']).e.c + 1;
            data['!cols'] = Array(totalColumns).fill({ wch: 20 });
            // Atura de filas
            const totalRows = XLSX.utils.decode_range(data['!ref']).e.r + 1;
            data['!rows'] = Array(totalRows).fill({ hpx: 20 });

            const workbook = XLSX.utils.book_new();
            const filename = 'Puntos-a-vencer';
            XLSX.utils.book_append_sheet(workbook, data, filename);
            XLSX.writeFile(workbook, `${filename}.xlsx`);
          }
        } 
        // else if(res.isDismissed) {
        //   console.log('No se descarga');
        // }
      });
    },
  },
  watch: {
    "form.initialDate": function(n) {
      if (n != null && n != "") {
        $('#finallyDate').attr("disabled", false);
        this.form.finallyDate = null;
      } else {
        $('#finallyDate').attr("disabled", true);
        this.form.finallyDate = null;
      }
    },
    "form.finallyDate": function(n) {
      if(n != null && n != ""){
        if(this.form.initialDate > n){
          this.$swal({
            icon: "info",
            title: "Lo sentimos",
            text: "La fecha final no puede ser menor que la fecha inicial",
            confirmButtonColor: "#dc3545"
          });
          this.form.finallyDate = null;
          return false;
        } else {
          return true;
        }
      }
    },
  },
  // mounted(){
  //   console.log('mounted');
  // }
};
</script>

<style scoped>
.container_dash{
  padding: 4% 0%;
  background-color: #eaeaea;
}
.info{
  background-color: #dc3545;
  padding: 20px;
  border-radius: 10px;
}
.info > strong{
  text-align: center;
  font-size: 16px;
  color:#fff;
  font-family: "GothamBookItalic", sans-serif;
}
.content_date{
  background: linear-gradient(
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.2)
  ), url('../../../assets/img/background_header_dash.webp');
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 400px;
  padding: 10%;
}
/* .btn_search{
  display: flex;
} */
.btn_search > button{
  padding: 8px 20px;
}
.title_sec_1{
  text-align: center;
  font-size: 20px;
  color:#595959;
  font-family: "GothamBoldItalic", sans-serif;
}
.cont_graphs_and_tables{
  padding: 4% 0%;
}
.cant_users{
  text-align: initial;
  font-size: 18px;
  color:#595959;
  font-family: "GothamBoldItalic", sans-serif;
  padding: 5px 12px;
}
.without{
  text-align: center;
  font-size: 20px;
  color:#dc3545;
  font-family: "GothamBoldItalic", sans-serif;;
  padding: 5px;
}
.chart-container {
  height: 90vh;
  width: 100%;
  margin: 20px 0px;
}
.chart {
  height: 90vh;
  width: 100%;
}
.codes_general{
  overflow:scroll;
  height: 500px;
}
.thead-dark{
  position: sticky;
  top: 0;
}
tfoot {
  position: sticky;
  bottom: 0;
  background-color: #eaeaea;
}
.btn_download{
  padding: 8px 40px;
  margin: 10px 0px;
  color: white !important;
  background-color: #343a40 !important;
  /* box-shadow: 0 0 15px #28a745; */
  filter: drop-shadow(0px 0px 10px #343a40);
}
.row_table{
  padding: 30px 0px;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 20px;
  --b: 5px; 
  /* aspect-ratio: 1; */
  border-radius: 50%;
  padding: 1px;
  background: conic-gradient(#0000 10%,#fff) content-box;
  -webkit-mask:
  repeating-conic-gradient(#0000 0deg,#000 1deg 20deg,#0000 21deg 36deg),
  radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
  mask-composite: intersect;
  animation: l4 1s infinite steps(10);
}
@keyframes l4 {to{transform: rotate(1turn)}}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* MOBILE */
@media (max-width: 768px) {
  .container_dash{
    padding: 18% 0%;
  }
  .info > strong{
    font-size: 14px;
  }
}


@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>